/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useState, useContext } from "react";
import AppContext from "../../../../Store/AppContext";
import {
  Listar as ListarFiltroDeDados,
  Detalhes as DetalhesFiltroDeDados,
  Remover as RemoverFiltroDeDados,
  Incluir as IncluirFiltroDeDados,
  Atualizar as AtualizarFiltroDeDados,
} from "../../../../Services/FiltroDeDados";

import { useHistory } from "react-router-dom";
import { validarPermissoesPagina } from "../../../../Utils/validarPermissoesPagina";
export const FiltroDeDadosContext = createContext();

const tituloTela = "Filtro de Dados";

const defaultData = {
  filtroDeDadosId: 0,
  filtroDeDadosNome: '',
  filtroDeDadosFiltro: '',
  filtroDeDadosLimiteRegistrosRetornados: 0
};

const searchData = {
  filtroDeDadosNome: "",
};

const columnsDefinition = [
  {
    text: "Id",
    dataField: "filtroDeDadosId",
    hidden: true,
  },
  {
    text: "Nome do Filtro",
    dataField: "filtroDeDadosNome",
    headerStyle: { width: "500px" },
    sort: true,
  },
  {
    text: "Lim. Registros",
    dataField: "filtroDeDadosLimiteRegistrosRetornados",
    headerStyle: { width: "100px" },
    sort: true,
  },
];

function initialState() {
  return {
    searchData: searchData,
    resultSearch: [],
    columnsDefinition: columnsDefinition,
    data: defaultData,
    formDisabled: true,
    produtos: [],
    chavesTemplate: [],
  };
}

const FiltroDeDadosProvider = ({ children }) => {
  const { showLoading, hideLoading, showMessage, setTituloTela } = useContext(
    AppContext
  );
  const [values, setValues] = useState(initialState());
  let history = useHistory();

  async function loadDependences() {
    const permissoesPagina = validarPermissoesPagina();

    return { permissoesPagina };
  }

  const resetScreen = () => {
    showLoading();
    async function carregarDependencias() {
      const dependencias = await loadDependences();
      setTituloTela(tituloTela);
      setValues({
        ...initialState(),
        permissoesPagina: await dependencias.permissoesPagina,
        produtos: await dependencias.produtos,
        chavesTemplate: await dependencias.chavesTemplate,
      });
      hideLoading();
    }
    carregarDependencias();
  };

  const searchHandler = async () => {
    showLoading();
    const responseListar = await ListarFiltroDeDados(values.searchData);
    if (!responseListar.success) {
      showMessage("Erro", "Erro Inesperado durante a pesquisa.");
      hideLoading();
      return;
    }

    const resultSearchData = await responseListar.filtrosDeDados;

    resultSearchData.map((data) => (data.Id = data.filtroDeDadosId));

    setValues({
      ...values,
      resultSearch: resultSearchData,
    });

    if (resultSearchData.length === 0) {
      showMessage("Alerta", "Nenhum registro encontrado.");
    }
    hideLoading();
  };

  const removeHandler = async (id) => {
    showLoading();

    const responseRemover = await RemoverFiltroDeDados(id);

    if (!responseRemover.success) {
      hideLoading();
      showMessage(
        "Erro",
        `Erro durante a exclusão: ${responseRemover.message}`
      );
      return;
    }
    searchHandler();
    hideLoading();
    showMessage("Sucesso", "Registro excluido.");
  };

  const getDetailHandler = async (id) => {
    showLoading();
    const dependencias = await loadDependences();

    if (id > 0) {
      const responseDetalhes = await DetalhesFiltroDeDados(id);
      const { success, filtroDeDados } = await responseDetalhes;
      if (!success) {
        showMessage("Erro", "Erro ao buscar os detalhes do registro.");
        setValues({
          ...values,
          data: defaultData,
          permissoesPagina: await dependencias.permissoesPagina,
        });
      }

      setValues({
        ...values,
        data: filtroDeDados,
        permissoesPagina: await dependencias.permissoesPagina
      });

    } else {
      setValues({
        ...values,
        data: {
          ...defaultData,
          filtroDeDadosId: 0,
        },
        permissoesPagina: await dependencias.permissoesPagina,
        formDisabled: false,
      });
    }
    hideLoading();
  };

  const createData = async () => {
    showLoading();
    const responseIncluir = await IncluirFiltroDeDados(values.data);
    if (!responseIncluir.success) {
      hideLoading();
      showMessage(
        "Erro",
        `Erro ao criar o registro: ${responseIncluir.message}`
      );
      responseIncluir.errors.map((erro) =>
        showMessage("Erro", erro.errorMessage)
      );
      return;
    }

    resetScreen();
    hideLoading();
    showMessage("Sucesso", "Registro criado.");
    history.goBack();
  };

  const editHandler = () => {
    setValues({
      ...values,
      formDisabled: false,
    });
  };

  const updateData = async () => {
    showLoading();
    const responseAtualizar = await AtualizarFiltroDeDados(values.data);
    if (!responseAtualizar.success) {
      hideLoading();
      showMessage(
        "Erro",
        `Erro ao atualizar o registro: ${responseAtualizar.message}`
      );
      responseAtualizar.errors.map((erro) =>
        showMessage("Erro", erro.errorMessage)
      );
      return;
    }
    resetScreen();
    hideLoading();
    showMessage("Sucesso", "Registro atualizado.");
    history.goBack();
  };

  const saveHandler = async () => {
    if (values.data.filtroDeDadosId === 0) {
      await createData();
    } else {
      await updateData();
    }
  };

  const cancelHandler = () => {
    setValues({
      ...values,
      data: defaultData,
      formDisabled: true,
    });
  };

  return (
    <FiltroDeDadosContext.Provider
      value={{
        values,
        setValues,
        resetScreen,
        searchHandler,
        cancelHandler,
        removeHandler,
        saveHandler,
        getDetailHandler,
        editHandler,
      }}
    >
      {children}
    </FiltroDeDadosContext.Provider>
  );
};

export default FiltroDeDadosProvider;
